import React, { createContext, useContext } from "react";
import { message } from "antd";
import type { MessageInstance } from "antd/es/message/interface";

interface MessageContextValue {
  messageApi: MessageInstance;
}

const MessageContext = createContext<MessageContextValue | null>(null);

export const MessageProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider value={{ messageApi }}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};

export const useMessageContext = (): MessageContextValue => {
  const context = useContext(MessageContext);

  if (!context) {
    throw new Error("useMessageContext must be used within MessageProvider");
  }

  return context;
};
